import { useState, useEffect } from "react";

import { PaymentModel } from "../../../../models/PaymentModels";
import { WalletModels } from "../../../../models/WalletModels";
import { useAdminApi } from "./useAdminApi";
import { useToast } from "../../../../hooks/toast";

export const usePaymentBusiness = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadError, setLoadError] = useState<string | null>(null);
  const [payments, setPayments] = useState<PaymentModel[]>([]);
  const [maxPage, setMaxPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const { fetchPayments, fetchWallet } = useAdminApi();
  const { addToast } = useToast();

  const [wallet, setWallet] = useState<WalletModels>({
    available: 0,
    balance: 0,
    schoolid: "",
  });

  const showLoadError = () =>
    addToast({
      type: "error",
      title: "Erro ao carregar pagamentos",
      description:
        "Não foi possível buscar os dados. Recarregue a página para tentar de novo.",
    });

  const fetchMorePayments = async () => {
    const nextPage = currentPage + 1;
    if (nextPage > maxPage) {
      return;
    }

    setIsLoading(true);
    try {
      const newPayments = await fetchPayments(nextPage);
      setPayments((oldPayments) =>
        oldPayments.concat(newPayments.data.payments ?? [])
      );
      if (newPayments.data.pages !== maxPage) {
        setMaxPage(newPayments.data.pages);
      }
      setCurrentPage(nextPage);
    } catch {
      showLoadError();
    } finally {
      setIsLoading(false);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    setLoadError(null);
    try {
      const _wallet = await fetchWallet();

      const _payments = await fetchPayments(currentPage);
      setMaxPage(_payments.data.pages ?? 0);
      setPayments(_payments.data.payments ?? []);
      setWallet(_wallet.data);
    } catch {
      setLoadError("Não foi possível carregar a carteira e os pagamentos.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isLoading,
    loadError,
    payments,
    wallet,
    fetchMorePayments,
    fetchData,
    currentPage,
    maxPage,
  };
};
